/**
 * Shared source-of-truth for the "launch video" surfaces on the v3 landing page
 * (hero-collage card + vision-section film widget).
 */
export const LAUNCH_VIDEO_SRC = '/assets/landing-v3/hero-loop-v3.mp4'
export const LAUNCH_VIDEO_POSTER_SRC = '/assets/landing-v3/hero-cards/launch-video-first-frame.png'
